<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oc8piW/tc-custom/FC-9781528951920.jpg?1685327250229?1705540336489" alt="This image is the cover for the book From Rehab to Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Rehab to Life
      </h1>
      <p class="bookDescription body article font2">
        <p>Whether in or out of trouble, please say this serenity prayer on a daily basis: "God, grant me the serenity to accept the things I cannot change, courage to change the things I can and the wisdom to know the difference." Thy will be done.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tamara Gabriel
      </h2>
      
      <p class="authorDescription body article">Tamara Gabriel is a singer-songwriter, poet, radio-TV presenter, actor and voice-over artist who descended into the abyss of crime, violence and drug addiction, but found the strength, courage and support to ascend in life. Enriched by these experiences, the author now seeks to empower those grappling with such challenges and to steer others clear from the mental and physical prison of torture, pain, anger, regret, remorse, resistance, guilt and shame.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1eb5035b